// The supplied mission geometry and state progression, with scoped lifecycle cleanup.
export function createMissionController(root, tr, views, reducedMotion) {
let missionStage=0, missionProgress=0, missionPlaying=false, missionLast=0, frame=0, visible=true;
const missionTitles=views.missionTitles, missionCopy=views.missionCopy;
function paintMission() {
  
  if (!root) return;
  const p = missionProgress,
    s = missionStage,
    c = missionCopy()[s];
  root.dataset.stage = s;
  root.classList.toggle('is-playing', missionPlaying);
  root.querySelectorAll('[data-stage]').forEach(b => b.setAttribute('aria-pressed', Number(b.dataset.stage) === s));
  root.querySelector('#mission-heading').textContent = c[0];
  root.querySelector('#mission-description').textContent = c[1];
  root.querySelector('#mission-insight').textContent = c[2];
  root.querySelector('#mission-step').textContent = `0${s + 1} / ${missionTitles()[s]}`;
  root.querySelector('#mission-play').textContent = missionPlaying ? tr('Ⅱ थांबवा', 'Ⅱ Pause') : tr('▶ डेमो सुरू करा', '▶ Play walkthrough');
  root.querySelector('#mission-range').value = p * 100;
  const route = root.querySelector('#mission-route'),
    len = route.getTotalLength();
  let coverage = s < 2 ? 0 : s === 2 ? p * .25 : s === 3 ? .25 : s === 4 ? .25 + Math.max(0, (p - .25) / .75) * .75 : 1;
  let pt = {
    x: 42,
    y: 340
  };
  if (s === 1) pt = route.getPointAtLength(0);
  if (s === 2) pt = route.getPointAtLength(len * coverage);
  const bp = route.getPointAtLength(len * .25),
    end = route.getPointAtLength(len);
  const lerp = (a, b, k) => ({
    x: a.x + (b.x - a.x) * k,
    y: a.y + (b.y - a.y) * k
  });
  if (s === 3) pt = lerp(bp, {
    x: 42,
    y: 340
  }, p);
  if (s === 4) pt = p < .25 ? lerp({
    x: 42,
    y: 340
  }, bp, p * 4) : route.getPointAtLength(len * coverage);
  if (s === 5) pt = lerp(end, {
    x: 42,
    y: 340
  }, p);
  if (s === 6) pt = {
    x: 250 + Math.min(p, .5) * 30,
    y: 195
  };
  if (s === 7) pt = route.getPointAtLength(len * p);
  root.querySelector('#mission-drone').setAttribute('transform', `translate(${pt.x} ${pt.y})`);
  root.querySelector('#break-marker').setAttribute('transform', `translate(${bp.x - 165} ${bp.y - 292})`);
  root.querySelector('#home-route').setAttribute('d', `M${s === 5 ? end.x : bp.x} ${s === 5 ? end.y : bp.y}L42 340`);
  const trail = root.querySelector('#spray-trail');
  trail.style.strokeDasharray = `${len * coverage} ${len}`;
  route.style.strokeDasharray = s === 1 ? `${len * p} ${len}` : '5 6';
  root.querySelector('#mission-area').textContent = (s > 5 ? '—' : (coverage * 4).toFixed(2)) + ' / 4 ac';
  root.querySelector('#mission-percent').textContent = s > 5 ? '—' : Math.round(coverage * 100) + '%';
  const spraying = s === 2 || s === 4 && p >= .25;
  root.classList.toggle('spraying', spraying);
  root.querySelector('#mission-spray').textContent = spraying ? tr('सुरू', 'ON') : tr('बंद', 'OFF');
}
const stop=()=>{missionPlaying=false;cancelAnimationFrame(frame);frame=0;missionLast=0;paintMission();};
const tick=(t)=>{if(!missionPlaying||document.hidden||!root.isConnected||!visible){stop();return;}if(missionLast)missionProgress+=Math.min(t-missionLast,100)/6500;missionLast=t;if(missionProgress>=1){if(missionStage<7){missionStage++;missionProgress=0;}else{missionProgress=1;missionPlaying=false;}}paintMission();if(missionPlaying)frame=requestAnimationFrame(tick);};
const select=(i)=>{stop();missionStage=Math.max(0,Math.min(7,i));missionProgress=reducedMotion.matches?1:0;if(i===0)missionProgress=0;paintMission();};
const scrub=(v)=>{stop();missionProgress=Math.max(0,Math.min(1,Number(v)/100));paintMission();};
const toggle=()=>{if(missionPlaying){stop();return;}cancelAnimationFrame(frame);if(missionStage===7&&missionProgress>=1){missionStage=0;missionProgress=0;}missionPlaying=true;missionLast=0;paintMission();frame=requestAnimationFrame(tick);};
const visibility=()=>{if(document.hidden)stop();};
let observer;if('IntersectionObserver' in window){observer=new IntersectionObserver(entries=>{for(const e of entries){visible=e.isIntersecting;if(visible)root.classList.add('mission-visible');else stop();}},{threshold:.15});observer.observe(root);}else root.classList.add('mission-visible');
document.addEventListener('visibilitychange',visibility);
const motionChange=()=>{if(reducedMotion.matches)stop();};reducedMotion.addEventListener?.('change',motionChange);
paintMission();
return {select,scrub,toggle,destroy(){cancelAnimationFrame(frame);observer?.disconnect();document.removeEventListener('visibilitychange',visibility);reducedMotion.removeEventListener?.('change',motionChange);}};
}
